import React from "react";

const stats = [
  { value: "1500+", label: "Placements" },
  { value: "400+", label: "Companies" },
  { value: "1000+", label: "Publications" },
  { value: "80+", label: "Awards" },
];

export default function StatsStrip() {
  return (
<section className="w-full bg-[#12539F] mt-10 mb-20">
  <div className="mx-auto grid max-w-7xl grid-cols-2 md:grid-cols-4">
    {stats.map((stat, index) => (
      <div
        key={stat.label}
        className={`
          relative flex flex-col items-center justify-center
          px-6 py-8 text-center
          sm:py-10
          ${index >= 2 ? "border-t border-white/20 md:border-t-0" : ""}
        `}
      >
        {/* Small vertical divider */}
        {index !== 0  && (
          <span className="absolute left-0 top-1/2 hidden h-10 -translate-y-1/2 w-px bg-white/20 md:block" />
        )}

        {/* Mobile dividers */}
        {index === 1 && (
          <span className="absolute right-0 top-1/2 h-10 -translate-y-1/2 w-px bg-white/20 md:hidden" />
        )}

        <span className="font-heading text-3xl text-white sm:text-4xl lg:text-5xl">
          {stat.value}
        </span>

        <span className="mt-2 text-sm font-medium tracking-wide text-white/80 sm:text-base">
          {stat.label}
        </span>
      </div>
    ))}
  </div>

  <div className="pb-6 pt-4 text-center text-sm text-white/70">
    Source: Mahindra University – Placement and Institutional Data
  </div>
</section>
 );
}